// extracted by css-extract-rspack-plugin
export default {"content":"S6F19rSSCKkBL9hD"};